export default "__VITE_ASSET__CakPHzkK__"